import { createContext, ReactNode, useContext, useState } from "react";
import { OverlayPage } from "../components/PitchControls/OverlayDropdown/overlayPageConfig";
import type { SelectedOverlay } from "../components/PitchControls/types";

interface OverlayContextProps {
  selectedOverlay: SelectedOverlay;
  setSelectedOverlay: (value: SelectedOverlay) => void;
  overlayPage: OverlayPage;
}

const OverlayContext = createContext<OverlayContextProps | null>(null);

interface OverlayProviderProps {
  children: ReactNode;
  defaultOverlay?: SelectedOverlay;
  page?: OverlayPage;
}

export const OverlayProvider = ({
  children,
  defaultOverlay = "opponent",
  page = "myTeam",
}: OverlayProviderProps) => {
  const [selectedOverlay, setSelectedOverlay] =
    useState<SelectedOverlay>(defaultOverlay);

  return (
    <OverlayContext.Provider
      value={{
        selectedOverlay,
        setSelectedOverlay,
        overlayPage: page,
      }}
    >
      {children}
    </OverlayContext.Provider>
  );
};

export const useOverlayContext = () => {
  const context = useContext(OverlayContext);
  if (!context) {
    throw new Error("useOverlayContext must be used within an OverlayProvider");
  }
  return context;
};
